<template>
  <div class="classroom-screen" :style="{ width: `${width}px`, height: `${0.5625 * width}px` }">
    <div class="classroom-content" :style="{ transform: `scale(${scale})` }">
      <div class="screen-top">
        <img src="@/assets/classroom/title.png" class="screen-title" />
        <div class="screen-top-left flex-box align-center">
          <DeptSelect v-model="dept" :dept-list="deptList" />
          <a-icon type="fullscreen-exit" class="fullscreen-icon" @click="toggleFullScreen" v-if="fullScreen" />
          <a-icon type="fullscreen" class="fullscreen-icon" @click="toggleFullScreen" v-else />
        </div>
        <div class="screen-top-right" v-if="buddhismInfo">
          <a-icon type="rollback" class="back-icon" @click="onHideBuddhism" />
        </div>
      </div>
      <BuddhismDetail :id="buddhismInfo?.id" @back="onHideBuddhism" v-show="!!buddhismInfo" class="classroom-main" />
      <div class="classroom-main" v-show="!buddhismInfo">
        <div class="screen-side classroom-left">
          <Notice :info="info" />
          <Ledger :info="info" />
          <Duty :info="info" />
        </div>
        <div class="screen-middle">
          <BuddhistActivity :info="info" @detail="showBuddhismDetail" />
          <ReceptionActivity :info="info" class="reception-activity-box" />
        </div>
        <div class="screen-side classroom-right">
          <div class="flex-box">
            <Crowd :info="info" class="crowd-box flex-grow" />
            <BuddhistDynamic :info="info" class="flex-grow" />
          </div>
          <Car :info="info" />
          <Worship :info="info" />
          <div class="flex-box">
            <DeptConsume :info="info" class="flex-grow" />
            <SengLiao :info="info" class="flex-grow sengliao-box" />
          </div>
        </div>
      </div>
    </div>
    <div class="loading-box" v-if="loading">
      <a-spin size="large" class="loading-spin" />
    </div>
  </div>
</template>

<script>
import DeptSelect from "./layouts/classroom/DeptSelect.vue";
import Notice from "./layouts/classroom/Notice.vue";
import Ledger from "./layouts/classroom/Ledger.vue";
import Duty from "./layouts/classroom/Duty.vue";
import BuddhistActivity from "./layouts/classroom/BuddhistActivity.vue";
import ReceptionActivity from "./layouts/classroom/ReceptionActivity.vue";
import Crowd from "./layouts/classroom/Crowd.vue";
import BuddhistDynamic from "./layouts/classroom/BuddhistDynamic.vue";
import Car from "./layouts/classroom/Car.vue";
import Worship from "./layouts/classroom/Worship.vue";
import DeptConsume from "./layouts/classroom/DeptConsume.vue";
import SengLiao from "./layouts/classroom/SengLiao.vue";
import BuddhismDetail from "./layouts/classroom/BuddhismDetail.vue";

export default {
  name: "ClassroomScreen",
  components: {
    DeptSelect,
    Notice,
    Ledger,
    Duty,
    BuddhistActivity,
    ReceptionActivity,
    Crowd,
    BuddhistDynamic,
    Car,
    Worship,
    DeptConsume,
    SengLiao,
    BuddhismDetail,
  },
  props: {
    value: { type: Number },
    deptList: { type: Array },
    width: { type: Number },
    fullScreen: { type: Boolean },
  },
  data() {
    return {
      loading: false,
      // width: 0,
      info: null,
      buddhismInfo: null,
    };
  },
  computed: {
    scale() {
      return this.width / 1920;
    },
    dept: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    full: {
      get() {
        return this.fullScreen;
      },
      set(val) {
        this.$emit("update:fullScreen", val);
      },
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    // 添加全屏状态变化监听
    document.addEventListener("fullscreenchange", this.handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", this.handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", this.handleFullscreenChange);
    document.addEventListener("MSFullscreenChange", this.handleFullscreenChange);
  },
  beforeDestroy() {
    // 移除事件监听
    document.removeEventListener("fullscreenchange", this.handleFullscreenChange);
    document.removeEventListener("webkitfullscreenchange", this.handleFullscreenChange);
    document.removeEventListener("mozfullscreenchange", this.handleFullscreenChange);
    document.removeEventListener("MSFullscreenChange", this.handleFullscreenChange);
  },
  methods: {
    getData() {
      if (this.loading) return;
      this.loading = true;
      this.$axios("/admin/dept-datas/new-ke-tang")
        .then((res) => {
          this.info = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 处理全屏状态变化
    handleFullscreenChange() {
      this.full = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );
    },
    toggleFullScreen() {
      const element = document.documentElement;
      if (this.full) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.full = !this.full;
    },
    showBuddhismDetail(detail) {
      console.log("showBuddhismDetail:", detail);
      this.buddhismInfo = detail;
    },
    onHideBuddhism() {
      this.buddhismInfo = null;
    },
  },
};
</script>
<style lang="less">
::-webkit-scrollbar {
  width: 2px;
  height: 5px;
}
.classroom-screen {
  --primary-color: #f8ba14;
}
.screen-table {
}
</style>
<style lang="less" scoped>
.loading-box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  .loading-spin {
    color: var(--primary-color);
  }
}
.classroom-screen {
  position: relative;
  background: #000000;
}
.classroom-content {
  position: relative;
  width: 1920px;
  height: 1080px;
  transform-origin: 0 0;
  color: #fff;
}
.classroom-main {
  position: relative;
  padding: 74px 20px 25px;
  width: 100%;
  height: 100%;
  background: url(../../../assets/classroom/border.png) center / contain no-repeat;
}
.screen-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  font-size: 14px;
}
.screen-top-left {
  display: flex;
  align-items: center;
  position: absolute;
  top: 44px;
  left: 67px;
  z-index: 1;
}
.fullscreen-icon {
  font-size: 24px;
  margin-left: 24px;
  color: var(--primary-color);
  cursor: pointer;
}
.screen-title {
  width: 788px;
  height: 124px;
  cursor: pointer;
  z-index: 1;
}
.screen-top-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  top: 44px;
  right: 67px;
  width: 482px;
  z-index: 1;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 1.4px;
}
.back-icon {
  color: var(--primary-color);
  font-size: 24px;
}

.classroom-main {
  display: flex;
}
.screen-side {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 14px 12px;
  width: 499px;
}
.screen-middle {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
  padding: 50px 70px 14px;
}
.reception-activity-box {
  margin-top: 12px;
}
.crowd-box {
  margin-right: 34px;
}
.sengliao-box {
  margin-left: 17px;
}
</style>
